module.exports = __webpack_public_path__ + "static/img/pic_logon_step1@2x.a08fc16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contactUs/establishmentProcess/pic_logon_step1@2x.png
// module id = sdyl
// module chunks = 0